import { render, staticRenderFns } from "./PersonList.vue?vue&type=template&id=58c6500a&"
import script from "./PersonList.vue?vue&type=script&lang=js&"
export * from "./PersonList.vue?vue&type=script&lang=js&"
import style0 from "./PersonList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\rd_mingyi_liu\\Desktop\\自定义控件快速开发包\\custom_stage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58c6500a')) {
      api.createRecord('58c6500a', component.options)
    } else {
      api.reload('58c6500a', component.options)
    }
    module.hot.accept("./PersonList.vue?vue&type=template&id=58c6500a&", function () {
      api.rerender('58c6500a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/web/isv/kingdee/hr/selectPerson/components/PersonList.vue"
export default component.exports